const COMPARISON_VARIABLE_NAMES = [
  'grossSales',
  'netSales',
  'grossProfit',
  'transaction',
  'averageSalePerTransaction',
  'grossMargin',
] as const;

type ComparisonVariableNames = (typeof COMPARISON_VARIABLE_NAMES)[number];

const COMPARISON_TAB_DATA: { key: ComparisonVariableNames; value: string }[] = [
  {
    key: 'grossSales',
    value: 'Gross Sales',
  },
  {
    key: 'netSales',
    value: 'Net Sales',
  },
  {
    key: 'grossProfit',
    value: 'Gross Profit',
  },
  {
    key: 'transaction',
    value: 'Transaction',
  },
  {
    key: 'averageSalePerTransaction',
    value: 'Avg Sale per Transaction',
  },
  {
    key: 'grossMargin',
    value: 'Gross Margin',
  },
];

const COMPARISON_DATA_DETAILS: {
  [TYPE in ComparisonVariableNames]: { title: string; format: 'decimal' | 'currency' | 'percent' };
} = {
  grossSales: {
    title: 'Gross Sales',
    format: 'currency',
  },
  netSales: {
    title: 'Net Sales',
    format: 'currency',
  },
  grossProfit: {
    title: 'Gross Profit',
    format: 'currency',
  },
  transaction: {
    title: 'Transaction',
    format: 'decimal',
  },
  averageSalePerTransaction: {
    title: 'Avg Sale per Transaction',
    format: 'currency',
  },
  grossMargin: {
    title: 'Gross Margin',
    format: 'percent',
  },
};

export { COMPARISON_VARIABLE_NAMES, type ComparisonVariableNames, COMPARISON_DATA_DETAILS, COMPARISON_TAB_DATA };
